import React, { useEffect } from "react";
import { useStateIfMounted } from "use-state-if-mounted";
import { useHistory } from 'react-router-dom';
import auth from "../../../core/auth";

export const Info = props => {
  const [state, setState] = useStateIfMounted({
    first_name: "",
    last_name: "",
    username: "",
    email : "",
    mailsyn:false,
    date:"",
    loading:true,
  });

  const history = useHistory();
  const handleClick = () => history.push('/');

  useEffect(() => {
    let user_information = auth.getUserData();
    setState({...state,
      first_name: user_information.first_name,
      last_name: user_information.last_name,
      username: user_information.username,
      email : user_information.email,
      mailsyn:user_information.mailsyn,
      date:user_information.date,
      loading:false,
    });
  },[]);

  if(state.loading){
    return(
    <div className="container">
      <center>
        <img
            src={require("./../../../images/simpleloading.gif")}
            className="simpleloadingview"
        />
        <p>
          <strong>Loading registration ...</strong>
          <br />
        </p>
      </center>
    </div>
  );
  }else{
    return (
      <React.Fragment>
        <div className="container">
        <div className="card text-center bg-light mb-3 infocard" >
          <img className="card-img-top" src={require("./../../../images/contact.png")} />
          <div className="card-body">
            <h5 className="card-title">{state.username}</h5>
            <p className="card-text">
              First name:<strong> {state.first_name} </strong><br></br>
              Second name:<strong> {state.last_name} </strong><br></br>
              Email:<strong> {state.email} </strong><br></br>
              Email syncronization:<strong> {(state.mailsyn)?<span>&#9745;</span>:<span>&#9746;</span>} </strong><br></br>
              Registered date:<strong> {(state.date != "")?new Date(state.date*1000).toLocaleDateString("en-US"):"N/A"} </strong><br></br>
              <strong>Verified account.</strong>
            </p>
            <a href="#" className="btn btn-primary" onClick={() => handleClick()}>Back</a>
          </div>
        </div>
        </div>
      </React.Fragment>
    );
  }
};
